import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function CookieNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("ptg_cookie_ok")) setShow(true);
  }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 bg-slate-900 text-white p-4 shadow-2xl" data-testid="cookie-notice">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center gap-4 justify-between">
        <p className="text-sm text-slate-300 flex items-center gap-2">
          <Cookie className="h-5 w-5 text-amber-400 shrink-0" />
          We use minimal cookies to improve your experience. By using this site you agree to our privacy policy.
        </p>
        <Button size="sm" className="bg-amber-500 hover:bg-amber-600 font-semibold shrink-0"
          onClick={() => { localStorage.setItem("ptg_cookie_ok", "1"); setShow(false); }}
          data-testid="cookie-accept">
          Got it
        </Button>
      </div>
    </div>
  );
}
